import { updateImage, updateImageUrl } from '../api/imageProjectApi';
import { setLoadingSave } from '../../store/slices/imageSlice';
import { AppDispatch } from '../../store/store';
import { rotateImageFile } from '../helpers/imageHelpers';
import { toast } from 'react-toastify';

interface HandleSavePromptParams {
    activePrompt: string | null;
    selectedImage: any;
    dispatch: AppDispatch;
    newImageWithEffects: any;
}

const changeImageUrl = async (dispatch: AppDispatch, newImageWithEffects: any, imageId: string) => {
    if (newImageWithEffects && imageId) {
        return await dispatch(
            updateImageUrl({
                imageId: imageId,
                file: newImageWithEffects,
            }),
        ).unwrap();
    }
};

export const handleSaveImage = async ({
    activePrompt,
    selectedImage,
    dispatch,
    newImageWithEffects,
}: HandleSavePromptParams): Promise<void> => {
    console.log('activePrompt', activePrompt);
    if (
        (activePrompt === 'adjust_colors' ||
            activePrompt === 'effects' ||
            activePrompt === 'resize') &&
        selectedImage?.image
    ) {
        if (!selectedImage.image) return;

        dispatch(setLoadingSave(true));

        try {
            if (activePrompt === 'adjust_colors') {
                await dispatch(
                    updateImage({
                        imageId: selectedImage.image.id,
                        visual_settings: selectedImage.image.visual_settings,
                        canvas_color: selectedImage.image.canvas_color,
                    }),
                ).unwrap();
                await changeImageUrl(dispatch, newImageWithEffects, selectedImage.image.id);
            } else if (activePrompt === 'effects') {
                if (selectedImage.image.visual_effects?.name !== '') {
                    await dispatch(
                        updateImage({
                            imageId: selectedImage.image.id,
                            visual_effects: selectedImage.image.visual_effects,
                            canvas_color: selectedImage.image.canvas_color,
                        }),
                    ).unwrap();
                    await changeImageUrl(dispatch, newImageWithEffects, selectedImage.image.id);
                }
            } else if (activePrompt === 'resize') {
                // if(selectedImage.image.transformation.rotation!==0){
                try {
                    const rotatedFile = await rotateImageFile(
                        newImageWithEffects,
                        selectedImage.image.transformation.rotation,
                    );
                    await dispatch(
                        updateImage({
                            imageId: selectedImage.image.id,
                            transformation: selectedImage.image.transformation,
                        }),
                    ).unwrap();
                    await changeImageUrl(dispatch, rotatedFile, selectedImage.image.id);
                } catch (err: any) {
                    toast.error(err?.message || 'Error rotating image');
                }
                // }
                // else{
                //     console.log('saveImage', newImageWithEffects);
                //     await dispatch(
                //         updateImage({
                //             imageId: selectedImage.image.id,
                //         transformation: selectedImage.image.transformation,
                //     }),
                // ).unwrap();
                //         await changeImageUrl(dispatch, newImageWithEffects, selectedImage.image.id);
                // }
            } else {
            }
        } finally {
            dispatch(setLoadingSave(false));
        }
    }
};
